module.exports = __webpack_public_path__ + "img/cloud-5.9af026d1.svg";